const account = r => require.ensure([], () => r(require('@/page/account/account')), 'account');
const accountList = r => require.ensure([], () => r(require('@/page/account/accountList/accountList')), 'accountList');
const openAccountList = r => require.ensure([], () => r(require('@/page/account/accountList/openAccountList')), 'openAccountList');
const notOpenAccountList = r => require.ensure([], () => r(require('@/page/account/accountList/notOpenAccountList')), 'notOpenAccountList');
const accountStatistics = r => require.ensure([], () => r(require('@/page/account/accountStatistics/accountStatistics')), 'accountStatistics');
const accountAbnormalList = r => require.ensure([], () => r(require('@/page/account/accountList/accountAbnormalList')), 'accountAbnormalList');
const accountDetails = r => require.ensure([], () => r(require('@/page/account/accountDetails/accountDetails')), 'accountDetails');

const accountRouter = {
  path: '',
  name: '共有资金账户管理',
  component: account,
  meta: {
    icon: 'expertInfo',
    right: [],
    isShowMenu: true,
  },
  children: [{
    path: '/accountList',
    component: accountList,
    name: '应开账户信息展示',
    meta: {
      right: ['应开账户信息展示'],
      isShowMenu: true,
      keepAlive:true,
    },
  }, {
    path: '/openAccountList',
    component: openAccountList,
    name: '已开账户信息',
    meta: {
      right: ['已开账户信息'],
      isShowMenu: false,
      keepAlive: false,
    },
  }, {
    path: '/notOpenAccountList',
    component: notOpenAccountList,
    name: '未开账户信息',
    meta: {
      right: ['未开账户信息'],
      isShowMenu: false,
      keepAlive: false,
    },
  }, {
    path: '/accountStatistics',
    component: accountStatistics,
    name: '账户信息统计',
    meta: {
      right: ['账户信息统计'],
      isShowMenu: false,
      keepAlive: false,
    },
  },{
    path: '/accountAbnormalList',
    component: accountAbnormalList,
    name: '账户异常管理',
    meta: {
      right: ['账户异常管理'],
      isShowMenu: false,
      keepAlive: false,
    },
  }, {
    path: '/accountDetails',
    component: accountDetails,
    name: '账户详情',
    meta: {
      right: ['账户详情'],
      isShowMenu: false,
      keepAlive: false,
    },
  }]
};
export default accountRouter;
